import { IPlacementDataTable } from "../types/placement"

export function getNewBidAdjustment(placement: IPlacementDataTable, minLimitedCPC: number): number {
  if (!placement.limitedCPC) {
    return 0
  }

  const newBidAdjustment = ((placement.limitedCPC - minLimitedCPC) / minLimitedCPC) * 100
  return Number(newBidAdjustment?.toFixed(0) || 0)
}
